import React from 'react';
import { stores } from '../../../stores';
import { checkLoginRequired, checkMaintenanceSportsbook } from '../../../services/navigator';
import MainLayout from '../../../layouts/main/MainLayout';
import { useStore } from '../../../hooks/useStore';

interface Props {
    loginRequired?: boolean;
    root?: boolean;
    render: (props) => JSX.Element;
    component: any;
    layout: any;
}

export default function NavigatorRender(props: Props) {
    const { loginRequired, root, render, component: Component, layout: Layout } = props;
    const [isAuthenticated] = useStore(stores.isAuthenticated);
    const [sportsbookMaintenanceState] = useStore(stores.maintenance.sportsbookMaintenanceState);

    const [loginRestriction, maintenanceRestriction] = [
        checkLoginRequired(loginRequired, root, isAuthenticated),
        checkMaintenanceSportsbook(sportsbookMaintenanceState),
    ];

    if (loginRestriction) {
        return Layout ? <Layout>{loginRestriction}</Layout> : loginRestriction;
    } else if (maintenanceRestriction) {
        return <MainLayout>{maintenanceRestriction}</MainLayout>;
    }

    if (Layout) {
        return (
            <Layout>
                <Component {...props} />
            </Layout>
        );
    }
    if (Component) {
        return <Component {...props} />;
    }
    if (render) {
        return render(props);
    }
    return null;
}
